import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  clRefetchJourney: false,
  journeyIsCollection: -1
}

export const contentLibrarySlice = createSlice({
  name: 'content_library',
  initialState,
  reducers: {
    setClRefetchJourney: (state, action) => {
      state.clRefetchJourney = action.payload;
    },
    setJourneyIsCollection: (state, action) => {
      state.journeyIsCollection = action.payload;
    }
  },
})

// Action creators are generated for each case reducer function
export const { setClRefetchJourney, setJourneyIsCollection } = contentLibrarySlice.actions

export default contentLibrarySlice.reducer